<template>
  <header>
    <template>
      <div id="banner" v-if="bannerMessage">
        <marquee behavior="scroll" direction="left" id="bannerMessage">
          {{ bannerMessage }}
        </marquee>
      </div>
    </template>

    <div class="ac-heading row">
      <div class="col-9">
        <a href="/dashboard"><img class="logo" :src="ThmLogo" alt="" role="presentation"></a>
      </div>

      <div class="col-3">


        <b-dropdown ref="topdrop" v-bind:text="FirstName" right class="topdropdown pull-right mt-3">
          <b-dropdown-item @click="doMyAccount()" id="myaccount">My Account</b-dropdown-item>
          <b-dropdown-item @click="doTutorials()" id="tutorials">Tutorials</b-dropdown-item>
          <b-dropdown-item @click="doNotifications()" id="notifications">Notifications</b-dropdown-item>
          <b-dropdown-item @click="doReports()" id="reports" v-show="isLifelineUser===false">Reports</b-dropdown-item>
          <b-dropdown-item @click="doTrainingPlans()" id="trainingplans">Training Plans</b-dropdown-item>
          <b-dropdown-item @click="doCertificates()" id="certificates">Certificates</b-dropdown-item>
          <b-dropdown-item @click="doLogout()" ref="logout" id="logout">Logout</b-dropdown-item>
        </b-dropdown>


        <div class="topspacing pull-right">
          <button class="btn-transparent" @click="doAvatarClick"><img class="avatar" v-bind:src="ImageURL" v-show="ImageLoaded===true" @load="avatarLoaded" @error="avatarError" width=50 height=50 /></button>
        </div>


        <div class="pull-right mt-3" id="go_to_inbox">
          <button class="btn-transparent bubblebutton" @click="goToInbox">
            <div class="inboxBubble" v-show="InboxNum>0">{{InboxNum}}</div>
            <font-awesome-icon icon="envelope" size="md" aria-label="Go to inbox"></font-awesome-icon>
          </button>
        </div>



        <div class="clearfix"></div>
      </div>
    </div>
    <div class="ie11">
      Notice: It looks like you are using Internet Explorer 11. There are some minor issues using Admin Center with this browser. It is recommended that you upgrade to Edge or to use Chrome or Firefox
    </div>
    <div id="headerbar" v-bind:class="{'row':true,'license-pool-administrator':hb===0,'license-pool-data-viewer':hb===1,'group-administrator':hb===2,'group-data-viewer':hb===3}">

      <div v-show="BuiltCrumb===true" class="col-12 tbreadcrumb text-center">
        <b-form-select :class="{'ib':true,'siselect':BOrg!==emptyguid}" name="ddlOrg" class="ib" v-model="BOrg" :options="BOrgs" v-on:change="getSelectedOrg" v-show="BOrgs.length>1"></b-form-select><span v-show="BOrgs.length>1&&BPools.length>1">&nbsp;&nbsp;&rarr;&nbsp;&nbsp;</span>
        <b-form-select :class="{'ib':true,'siselect':BPool!==emptyguid}" name="ddlPool" v-model="BPool" :options="BPools" v-on:change="getSelectedPool" v-show="BPools.length>1"></b-form-select><span v-show="BPools.length>1&&BGroups.length>1">&nbsp;&nbsp;&rarr;&nbsp;&nbsp;</span>
        <b-form-select :class="{'ib':true,'siselect':BGroup!==emptyguid}" name="ddlGroup" v-model="BGroup" :options="BGroups" v-on:change="getSelectedGroup" v-show="BGroups.length>1"></b-form-select>
      </div>

    </div>
    <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
  </header>
</template>

<style scoped>
  div.ac-heading {
    padding: 20px;
  }

  button.bubblebutton {
    position: relative;
  }

  div.tbreadcrumb {
    color: #FFF;
  }

    div.tbreadcrumb select {
      width: 18% !important;
    }

  div#headerbar {
    height: 70px;
    padding-top: 15px;
    background: url(/titlebar.png) !important;
    background-size: cover !important;
    background-position: center center !important;
  }

  div.inboxBubble {
    position: absolute;
    font-size: 1em;
    top: -12px;
    right: -12px;
    height: 25px;
    border-radius: 50%;
    width: 25px;
    color: #FFF;
    background-color: #357d70;
    text-align: center;
    cursor: pointer;
  }

  div.topspacing {
    margin-left: 25px;
    margin-right: 25px;
  }

  img.logo {
    height: 50px;
    width: 161.54px;
    margin-left: 10px;
  }

  #banner {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #f3b70c;
    color: #000;
    text-align: center;
    z-index: 9999;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    height: 18px;
    font-size: small;
  }
</style>


<script>

  import ConfirmDialogue from './ConfirmDialogue.vue'
  import bannerData from '../banner.json'; // adjust path as needed

  export default {
    name: 'ACHeader',
    components: { ConfirmDialogue },
    data() {
      return {
        hb: -1,
        BuiltCrumb: false,
        ClientID: null,
        FirstName: "Loading",
        ImageURL: "",
        ImageLoaded: false,
        InboxNum: 0,
        BOrg: this.emptyguid,
        BPool: this.emptyguid,
        BGroup: this.emptyguid,
        BOrgs: [],
        BPools: [],
        BGroups: [],
        ThmLogo: "/SIMmersion_logo.svg",
        bannerMessage: '',
        isLifelineUser:false
      }
    },
   created() {
     // directly read JSON data
      this.bannerMessage = bannerData.message;
    },
    mounted() {
      this.$bus.$on("AvatarUpdateEvent", (ud) => {
        this.ClientID = ud.ClientID;
        this.updateAvatar(ud);
      });

      this.$bus.$on("BreadcrumbUpdateEvent", (allorgs, allpools, allgroups, selectedorg, selectedpool, selectedgroup) => {
        this.buildBreadcrumb(allorgs, allpools, allgroups, selectedorg, selectedpool, selectedgroup);
      });

      this.$bus.$on("InboxBubbleEvent", (n) => {
        this.updateInboxBubble(n);
      });

      this.$bus.$on("LogoUpdateEvent", (l) => {
        this.ThmLogo = "data:image/png;base64, " + l;
      });

      this.ShowHideMenus(1000);


      this.AlreadyLoggedInAlert();
      this.CheckPortalLogin();

    },
    computed: {

    },
    methods: {
      avatarError() {
        this.ImageURL = "/genericAvatar.png";
        this.ImageLoaded = true;
      },
      avatarLoaded() {
        this.ImageLoaded = true;
      },
      buildBreadcrumb(allorgs, allpools, allgroups, orgselect, poolselect, groupselect) {

        this.BOrgs = [];
        this.BPools = [];
        this.BGroups = [];



        for (var org of allorgs) {
          this.BOrgs.push({
            html: org.OrganizationName,
            value: org.OrganizationID
          })
        }

        if (orgselect !== null) {
          for (var pool of allpools) {
            if (pool.OrganizationID === orgselect) {
              this.BPools.push({
                html: pool.LicensePoolName,
                value: pool.LicensePoolID
              });
            }
          }

          this.BPools.push({
            html: "--------------",
            value: null
          })
        }

        for (var pool of allpools) {
          if (!(orgselect !== null && pool.OrganizationID === orgselect)) {
            this.BPools.push({
              html: pool.LicensePoolName,
              value: pool.LicensePoolID
            })
          }
          if (poolselect !== null && pool.LicensePoolID === poolselect) {
            if (pool.IsAdmin) {
              this.hb = 0;
            }
            else {
              this.hb = 1;
            }
          }
        }

        if (allgroups.length > 0) {

          for (var group of allgroups) {
            //if (group.ParentID == '00000000-0000-0000-0000-000000000000') {
            this.BGroups.push({
              html: group.LicensePoolGroupName,
              value: group.LicensePoolGroupID
            });

            if (groupselect !== null && group.LicensePoolGroupID === groupselect) {
              if (group.IsAdmin) {
                this.hb = 2;
              }
              else {
                this.hb = 3;
              }
            }
            //}
          }
        }

        this.BOrgs.unshift({
          text: "--- All Organizations ---",
          value: this.emptyguid
        });
        this.BPools.unshift({
          text: "--- All Pools ---",
          value: this.emptyguid
        });
        this.BGroups.unshift({
          text: "--- All Groups ---",
          value: this.emptyguid
        });


        if (orgselect !== null) {
          this.BOrg = orgselect;
        }
        else {
          this.BOrg = this.BOrgs[0].value;
        }

        if (poolselect !== null) {
          this.BPool = poolselect;
        }
        else {
          this.BPool = this.BPools[0].value;
        }

        if (groupselect !== null) {

          this.BGroup = groupselect;
        }
        else {
          this.BGroup = this.BGroups[0].value;
        }

        this.BuiltCrumb = true;

      },
      doAvatarClick() {
        this.$refs.topdrop.show();
      },
      doMyAccount() {
        this.$router.push("/client/" + this.ClientID + "/myaccount");
      },
      doCertificates() {
        this.$router.push("/client/" + this.ClientID + "/certificates")
      },
      doNotifications() {
        this.$router.push("/client/" + this.ClientID + "/notifications");
      },
      doReports() {
        this.$router.push("/client/" + this.ClientID + "/reports");
      },
      doTrainingPlans() {
        this.$router.push("/client/" + this.ClientID + "/trainingplans");
      },
      doTutorials() {
        this.$router.push("/client/" + this.ClientID + "/tutorials");
      },
      getSelectedOrg(orgid) {
        if (orgid === this.emptyguid) {
          this.$router.push("/dashboard");
        }
        else {
          this.$router.push({ name: 'orgpools', params: { id: orgid } });
        }
      },
      getSelectedPool(poolid) {
        if (poolid === null) {
          return;
        }
        if (poolid === this.emptyguid) {
          this.$router.push("/dashboard");
        }
        else {
          this.$router.push({ name: 'pooldash', params: { id: poolid } });
        }
      },
      getSelectedGroup(groupid) {
        if (groupid === null) {
          return;
        }
        if (groupid === this.emptyguid) {
          if (this.BPool !== this.emptyguid) {
            this.$router.push("/pool/" + this.BPool + "/groups");
          }
          else {
            this.$router.push("/dashboard");
          }
        }
        else {
          this.$router.push({ name: 'groupdash', params: { id: groupid } });
        }
      },
      goToInbox() {
        this.$router.push("/client/" + this.ClientID + "/inbox");
      },
      updateAvatar(ud) {
        this.FirstName = ud.ClientName;
        this.ImageURL = "https://attachments.simmersion.com/" + ud.ClientID + ".png?r=" + Math.random(0, 100000);
      },
      updateInboxBubble(n) {
        this.InboxNum = n;
      },
      AlreadyLoggedInAlert() {

        if (localStorage.getItem("isSSOLogin") !== null) {
          sessionStorage.setItem("isSimmersionUser", true);
        }


        var isFirstLoad = sessionStorage.getItem('isFirstLoad');

        if (localStorage.getItem("udata") !== null && isFirstLoad == null) {
          var sdata = JSON.parse(localStorage.getItem("udata"));

          this.apiCommand([
            {
              Operation: "Client",
              Function: "GetClientByID",
              Fields: {
                ClientID: sdata.ClientID
              }
            }
          ], true).then(response => {
            var cr = JSON.parse(response.CommandResult);
            var cli = JSON.parse(cr.returnObjects[0].returnObject);

            this.$refs.confirmDialogue.show({
              title: 'Confirm',
              message: 'You are already logged in as [' + cli.EmailAddress + ']. \n To continue with the current login, select Continue. To log in as a different user, click Log Out.',
              okButton: 'Log Out',
            }).then((result) => {
              if (!result) {
                sessionStorage.setItem('isFirstLoad', false);
              } else {
                this.doLogout();
              }
            });

          })
        }
      },
      CheckPortalLogin() {

        var LanguagePortal = sessionStorage.getItem('LanguagePortal');

        if (LanguagePortal == null) {

          this.apiCommand([
            {
              Operation: "Organization",
              Function: "GetLanguagePortal",
              Fields: {
                PortalID: "7728DEAD-2980-4748-9213-D49B97B74AE8"
              }
            }
          ], true).then(response => {
            var cr = JSON.parse(response.CommandResult);
            var cli = JSON.parse(cr.returnObjects[0].returnObject);

            if (cli !== null) {
              sessionStorage.setItem("LanguagePortal", cr.returnObjects[0].returnObject);
            }

          })
        }
      },
      async ShowHideMenus(timeout) {
        setTimeout(async () => {
          const udata = JSON.parse(localStorage.getItem("udata"));
          const isSSO = sessionStorage.getItem("isSimmersionUser");

          if (!udata) return;

          try {
            // ✅ Reuse the API call instead of duplicating
            const response = await this.apiCommand([{
              Operation: "LicensePool",
              Function: "isLifelineUser",
              Fields: { ClientID: udata.ClientID }
            }]);

            const cr = JSON.parse(response.CommandResult);
            const flag = JSON.parse(cr.returnObjects[0].returnObject) === "true";

            // ✅ Save result in sessionStorage (always set)
            sessionStorage.setItem("isLifelineUser", flag ? "true" : "false");

            if(flag)
            {
              this.isLifelineUser=true;
            }
           

            // ✅ Only hide menus if Lifeline + SSO
            if (flag && isSSO) {
              const hiddenElements = [
                "go_to_inbox",
                "tutorials",
                "notifications",
                "trainingplans",
                "certificates"
              ];

              hiddenElements.forEach(id => {
                const el = document.getElementById(id);
                if (!el) return;

                el.style.display = "none";
                const parentLi = el.closest("li");
                if (parentLi) parentLi.style.display = "none";
              });
            }

            // ✅ Load language after handling menus
            Window.loadLanguageContent();

          } catch (err) {
            console.error("Error in ShowHideMenus:", err);
          }
        }, timeout);
      }

    }
  }
</script>
